import {getFirestore, getDoc, collection, doc} from "firebase/firestore";

import Event from "@/models/Event";
import {getEventDoc} from "@/shared/firebase_utils";

const state = {
  currentSubEvent: null,
};

const getters = {
    currentSubEvent: (state) => state.currentSubEvent,
};

const actions = {
  async setCurrentSubEvent({ commit }, payload) {
    await commit("setCurrentSubEvent", payload);
  },
  async initializeEvent({ commit }, eventId) {
    try {
      let doc = await getEventDoc(eventId);
      commit("setCurrentSubEvent", Event.fromFireStore(doc));
    } catch (error) {
      console.log("Error initialising sub-event: ", error);
    }
  },
  clearCurrentSubEvent({commit}){
    commit("clearCurrentSubEvent");
  }
};

const mutations = {
    setCurrentSubEvent: (state, currentSubEvent) => {
    state.currentSubEvent = currentSubEvent;
  },
  clearCurrentSubEvent: (state) => {
    state.clearCurrentSubEvent = null;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
